var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ws-info-act-picker"},_vm._l((_vm._value),function(valueItem,valueIndex){return _c('div',{key:valueIndex},[_vm._v(" "+_vm._s(valueItem)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }